import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/computer.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-ee36d6d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "left"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title-box" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = {
  key: 1,
  class: "team-name"
}
const _hoisted_9 = { class: "content-box" }
const _hoisted_10 = { class: "left-msg" }
const _hoisted_11 = { class: "download-box msg-box" }
const _hoisted_12 = { class: "left-text" }
const _hoisted_13 = { class: "uninstall-box msg-box" }
const _hoisted_14 = { class: "left-text" }
const _hoisted_15 = { class: "notice-box msg-box" }
const _hoisted_16 = { class: "left-text" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right-picture" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "555",
    height: "326",
    src: _imports_0,
    alt: "computer"
  })
], -1))
const _hoisted_18 = { class: "footer-box" }
const _hoisted_19 = {
  key: 0,
  class: "footer-text"
}
const _hoisted_20 = { class: "background-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_DeployPackageDownload = _resolveComponent("DeployPackageDownload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.IS_PRIVATE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.logoDashboardHeaderSrc,
              alt: "logo"
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('deployPreview.heroLine1')), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('deployPreview.heroLine2', { clientName: _ctx.brandConfig.client_name })), 1)
      ]),
      (_ctx.data.team_name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$t('deployPreview.currentTeam')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.data.team_name), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_CmSvgIcon, {
              name: "views/preview/_images/write",
              monochrome: "",
              "aria-hidden": false,
              "aria-label": "download"
            }),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('deployPreview.tipRenameLine1')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('deployPreview.tipRenameLine2')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_CmSvgIcon, {
              name: "views/preview/_images/uninstall",
              monochrome: "",
              "aria-hidden": false,
              "aria-label": "uninstalls"
            }),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('deployPreview.tipUninstallLine1')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('deployPreview.tipUninstallLine2')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_CmSvgIcon, {
              name: "views/preview/_images/notice",
              monochrome: "",
              "aria-hidden": false,
              "aria-label": "notice"
            }),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('deployPreview.tipDownloadLine1')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('deployPreview.tipDownloadLine2')), 1)
            ])
          ])
        ]),
        _hoisted_17
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (!_ctx.IS_PRIVATE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('deployPreview.footerPersonalUpgrade', { clientName: _ctx.brandConfig.client_name, pin: _ctx.data.pin_code || '' })), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_DeployPackageDownload, {
        data: _ctx.data,
        class: "footer-download el-card",
        style: {"padding":"16px"}
      }, null, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_CmSvgIcon, {
        name: "views/preview/_images/oval",
        class: "oval-box",
        monochrome: "",
        "aria-hidden": false,
        "aria-label": "oval"
      }),
      _createVNode(_component_CmSvgIcon, {
        name: "views/preview/_images/rectangular",
        class: "rect-box",
        monochrome: "",
        "aria-hidden": false,
        "aria-label": "rectangular"
      })
    ])
  ]))
}